import { createSelector } from '@ngrx/store'

export const getRolesState = createSelector(
  (state: any) => state.roles,
  (state: any) => state.get('list'),
)

export const getPermissionsState = createSelector(
  (state: any) => state.roles,
  (state: any) => state.get('permissions'),
)

export const getCreateRoleState = createSelector(
  (state: any) => state.roles,
  (state: any) => state.get('createRole'),
)

export const getUpdateRoleState = createSelector(
  (state: any) => state.roles,
  (state: any) => state.get('updateRole'),
)
